export const useStylesCompanyDetails = theme => {
	return {
		loadingContainer: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			width: '100%',
			height: '70px',
			marginTop: 20,
			paddingTop: '50px',
			paddingBottom: '50px',
			alignItems: 'center'
		},
		icon: {
			color: theme.palette.primary.main
		},
		clickableIcon: {
			color: theme.palette.primary.main,
			cursor: 'pointer',
			marginBottom: '10px'
		}
	};
};

export const useStylesContactForm = theme => {
	return {
		form: {
			flexBasis: '45%',
			[theme.breakpoints.down('sm')]: {
				flexBasis: '100%'
			}
		},
		map: {
			width: '50%',
			height: '50vh',
			[theme.breakpoints.down('sm')]: {
				width: '100%',
				marginTop: '2rem'
			}
		},
		mailTo: {
			color: 'inherit !important',
			textDecoration: 'none !important'
		},
		snackBar: {
			fontSize: '13px !important'
		}
	};
};

export const productDetailsCardStyles = (theme, themeinfo) => {
	return {
		card: {
			background: themeinfo.productCardBackgroundColor,
			color: '#707070',
			border: `1px solid ${themeinfo.productCardHeaderFontColor}`,
			height: '100%'
		},
		cardHeader: {
			background: themeinfo.productCardHeaderColor,
			color: themeinfo.productCardHeaderFontColor
		},
		cardButton: {
			color: 'white !important'
		}
	};
};

export const productOptionCardStyles = (theme, themeinfo, width) => {
	return {
		card: {
			background: themeinfo.productCardBackgroundColor,
			color: '#707070',
			border: `1px solid ${themeinfo.productCardHeaderFontColor}`,
			height: '100%'
		},
		cardHeader: {
			background: themeinfo.productCardHeaderColor,
			color: themeinfo.productCardHeaderFontColor
		},
		cardIcon: {
			textAlign: 'center',
			verticalAlign: 'middle',
			marginRight: '15px',
			height: '1em !important',
			width: '1em !important'
		},
		cardIconImage: {
			height: '100%',
			margin: '15%'
		},

		cardClickForMore: {
			color: themeinfo.productCardHeaderFontColor
		},

		cardFooter: {
			justifyContent: 'space-between'
		},

		cardButtonMain: {
			paddingRight: '32px',
			paddingLeft: '32px'
		},
		cardButton: {
			background: themeinfo.productCardHeaderFontColor,
			color: 'white !important'
		},

		cardProductMain: {
			paddingLeft: '32px',
			color: themeinfo.productCardHeaderFontColor,
			display: 'table'
		},
		cardProductPriceMain: {
			display: 'table-cell',
			verticalAlign: 'middle'
		},
		cardProductPrice: {
			fontWeight: 'bold'
		},
		productName: {
			fontSize: width < 387 ? '2.5rem' : '3rem'
		}
	};
};

export const faqStyles = (theme, faqData) => {
	return {
		header: {
			backgroundColor: faqData?.mainPrimaryColor,
			color: theme.palette.primary.contrastText,
			borderRadius: '10px'
		},
		cardIcon: {
			textAlign: 'center',
			border: '2px solid #6414AF',
			borderRadius: '10px',
			backgroundColor: '#FFFFFF',
			verticalAlign: 'middle',
			marginRight: '2px',
			height: '40px',
			width: '40px',
			color: '#7b1fa2'
		},
		cardIconImage: {
			width: '100%',
			padding: '3px'
		},
		panel: {
			margin: 0,
			border: 'none',
			'&:before': {
				display: 'none'
			},
			'&:first-child': {
				borderRadius: '20px 20px 0 0'
			},
			'&:last-child': {
				borderRadius: '0 0 20px 20px'
			},
			'&$expanded': {
				margin: 'auto'
			}
		},
		primaryTexts: {
			color: faqData?.mainPrimaryColor
		},
		primaryBackgrounds: {
			backgroundColor: faqData?.mainPrimaryColor
		},
		expanded: {},
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesProductDetailsCard = themeinfo => {
	return {
		card: {
			background: themeinfo.productCardBackgroundColor,
			color: '#707070'
		},
		cardHeader: {
			background: themeinfo.productCardHeaderColor,
			color: themeinfo.productCardHeaderFontColor
		},
		cardIcon: {
			textAlign: 'center',
			border: `2px solid ${themeinfo.productCardHeaderFontColor}`,
			borderRadius: '2px',
			backgroundColor: '#FFFFFF',
			verticalAlign: 'middle',
			marginRight: '15px'
		},
		cardIconImage: {
			height: '80%',
			margin: '10%'
		},

		cardClickForMore: {
			color: themeinfo.productCardHeaderFontColor
		},

		cardFooter: {
			justifyContent: 'space-between'
		},

		cardButtonMain: {
			paddingRight: '32px'
		},
		cardButton: {
			borderRadius: '5px',
			color: 'white !important'
		},

		cardProductMain: {
			paddingLeft: '32px',
			color: themeinfo.productCardHeaderFontColor,
			display: 'table'
		},
		cardProductPriceMain: {
			display: 'table-cell',
			verticalAlign: 'middle'
		},
		cardProductPrice: {
			fontWeight: 'bold'
		}
	};
};

export const useStylesHome = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesDescriptionNavProducts = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesDescriptionNavOptions = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesDisclosure = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesFastFacts = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesPrivacyPolicy = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesClaims = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesTermsConditions = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesDetails = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};

export const useStylesAbout = theme => {
	return {
		tabItem: {
			backgroundColor: theme.palette.background.default ?? '#ffffff'
		}
	};
};
